import { BaseFormEntityRequest } from './BaseFormEntityRequest';

export class FormBuyDocumentRequest extends BaseFormEntityRequest {
  title: string;
  isbnIssn: string;
  url?: string;
  id?: number;
}
